export const REG_FRACTION = /\d{0,2}\.?\d{0,2}/;
export const REG_NOT_ALLOW_CHARS = /[^0-9.]/;
